import React from 'react'
import PropTypes from 'prop-types'
import FastAvatar from '../../molecules/FastAvatar'
import { useCurrentClient } from '../../../api/clients'

function CurrentClientAvatar ({ size, className, style }) {
  const { data: client, isLoading } = useCurrentClient()

  return (
    <FastAvatar
      className={className}
      style={style}
      isLoading={isLoading}
      avatarUrl={client?.avatarUrl}
      abbreviation={client?.clientAbbreviation}
      size={size}
    />
  )
}

CurrentClientAvatar.propTypes = {
  size: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
}

CurrentClientAvatar.defaultProps = {
  size: 'xl'
}

export default CurrentClientAvatar
